import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	deleteModalTitle: {
		id: 'proforma-panel-in-issue-view-ui.controllers.use-handle-delete-form.delete-modal-title',
		defaultMessage: 'Delete ‘{formName}’ form ',
		description:
			'The title of the modal asking the user to confirm if they want to delete the form.',
	},
	deleteModalBody: {
		id: 'proforma-panel-in-issue-view-ui.controllers.use-handle-delete-form.delete-modal-body',
		defaultMessage: 'Deleting this form will be permanent and cannot be undone.',
		description:
			'The body content of the modal asking the user to confirm if they want to delete the form.',
	},
	deleteModalConfirm: {
		id: 'proforma-panel-in-issue-view-ui.controllers.use-handle-delete-form.delete-modal-confirm',
		defaultMessage: 'Delete form',
		description:
			'The text in the confirmation button of the modal asking the user to confirm if they want to delete the form.',
	},
	deleteModalCancel: {
		id: 'proforma-panel-in-issue-view-ui.controllers.use-handle-delete-form.delete-modal-cancel',
		defaultMessage: 'Cancel',
		description:
			'The text in the cancel button of the modal asking the user to confirm if they want to delete the form.',
	},
});
